export default __webpack_public_path__ + "static/media/wmadd.54125d4d.jpg";